<template>
  <v-app>
    <div id="main-wrap">
      <v-main v-if="injected">
        <!-- <v-fade-transition>
          <router-view :key="$route.name"></router-view>
        </v-fade-transition> -->
        <v-fade-transition hide-on-leave>
          <router-view :key="$route.name"></router-view>
        </v-fade-transition>
        <CookieNotice v-if="!$store.state.auth" />
        <EntitiesSnackbar v-else />
      </v-main>
    </div>
  </v-app>
</template>

<script>
import EntitiesSnackbar from "./views/landing/EntitiesSnackbar.vue";
import CookieNotice from "./views/landing/CookieNotice.vue";
import InitializeApp from "@/landing/actions/InitializeApp";

export default {
  components: {
    CookieNotice,
    EntitiesSnackbar,
  },
  name: "App",
  created() {
    new InitializeApp(this.$store, this.$echo).handle();
    // this.$store.dispatch("inject");
  },
  computed: {
    injected() {
      return this.$store.state.injected;
    },
  },
};
</script>
